import { ownerOf } from "./handles.js";
const ID_PATTERN = /^[a-z][a-z0-9-]*(?:\/[a-z][a-z0-9-]*)*$/;
export function validId(id, kind) {
    if (!ID_PATTERN.test(id))
        throw new TypeError(`Invalid ${kind} id: ${id}`);
}
export function assertOwner(value, owner, label) {
    if (ownerOf(value) !== owner)
        throw new TypeError(`${label} belongs to another game kit`);
}
export function safePriority(value, id) {
    const priority = value ?? 0;
    if (!Number.isSafeInteger(priority))
        throw new TypeError(`Priority for ${id} must be a safe integer`);
    return priority;
}
export function freezeEntries(entries, owner, numbers, id) {
    const zero = numbers.fromNumber(0);
    return Object.freeze(entries.map(([resource, coefficient]) => {
        assertOwner(resource, owner, `Mechanic ${id} resource`);
        if (!numbers.isFinite(coefficient) || numbers.cmp(coefficient, zero) <= 0) {
            throw new TypeError(`Mechanic ${id} coefficients must be positive and finite`);
        }
        return Object.freeze([resource, coefficient]);
    }));
}
//# sourceMappingURL=validation.js.map